// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__+l5a9","modal":"Modal_modal__5+qzG","modalWide":"Modal_modalWide__P1t15","closeBtn":"Modal_closeBtn__ID7pX"};